<script lang="ts">
  import Load from '../Load.svelte'
  import { onMount, getContext } from 'svelte'
  import { getOrders } from '../../api'
  import type { Country, Order } from '../../api/types'
  import { ordersAwaitRefetch } from '../store'
  import OrderDetails from './OrderDetails.svelte'
  import { profileContextKey } from '../context'

  export let userCountry: Country

  const userId = getContext(profileContextKey).getUserId()

  const limit = 2
  let offset = 0
  let orders: Order[] = []
  let total = 0

  const ordersQuery = getOrders(userId, limit, offset)

  $: {
    const { loading, error, data } = $ordersQuery
    if (!loading && !error && data) {
      orders = data.orders.data
      total = data.orders.meta.total
    }
  }

  async function fetchMoreOrders() {
    offset = orders.length
    await ordersQuery.fetchMore({
      variables: { offset },
      updateQuery: (prev, { fetchMoreResult }) => {
        return Object.assign({}, prev, {
          orders: {
            meta: fetchMoreResult.orders.meta,
            data: [...prev.orders.data, ...fetchMoreResult.orders.data],
          },
        })
      },
    })
  }

  async function refetchOrders() {
    orders = []
    offset = 0
    await ordersQuery.refetch()
  }

  onMount(async () => {
    if ($ordersAwaitRefetch) {
      await refetchOrders()
      ordersAwaitRefetch.set(false)
    }
  })
</script>

<style>
  table {
    width: 100%;
    border-collapse: collapse;
  }

  table tbody tr {
    border-bottom: 1px solid #dee0e2;
  }

  table tr:not(:first-child) td {
    padding-top: 5px;
  }

  table td {
    color: #090a0b;
    font-style: normal;
    font-weight: normal;
    line-height: 22px;
    padding-bottom: 1rem;
  }

  tfoot {
    cursor: pointer;
    text-align: center;
    width: auto;
  }

  tfoot td {
    color: #007bb3;
    font-style: normal;
    font-weight: normal;
    line-height: 22px;
    padding: 10px;
  }
</style>

<Load query={ordersQuery} name="orders">
  {#if orders.length === 0}
    <p>This user has not made any payments.</p>
  {/if}

  <table>
    <tbody>
    {#each orders as order}
      <tr>
        <td data-test={order.id}>
          <OrderDetails {order} {userCountry} />
        </td>
      </tr>
    {/each}
    </tbody>
    {#if orders.length < total}
      <tfoot on:click={fetchMoreOrders}>
      <tr>
        <td>View more</td>
      </tr>
      </tfoot>
    {/if}
  </table>
</Load>
